import React,{Fragment, Component} from 'react';
import WOW from 'wowjs';
import Header from './../Layout/Header';
import FooterPremium from './../Layout/FooterPremium';
import PageTitle from './../Layout/PageTitle';

import { sendContactEmail } from '../../api/emailsender/EmailSender';
import { serializeForm } from '../../api/emailsender/formSerialize';

class Careers extends Component{
	state = {
		formSubmitting: false,
		formFeedback: '',
		formError: '',
	};

	handleFormSubmit = async (e) => {
		e.preventDefault();
		const form = e.currentTarget;
		if (!form.checkValidity()) {
			form.reportValidity();
			return;
		}
		this.setState({ formSubmitting: true, formFeedback: '', formError: '' });
		const formData = serializeForm(form);
		formData.formSource = 'Careers';
		const result = await sendContactEmail(formData, 'Star Giga — Careers application');
		this.setState({ formSubmitting: false });
		if (result.ok) {
			this.setState({ formFeedback: 'Thank you! Your application has been submitted.' });
			form.reset();
		} else {
			this.setState({ formError: result.error });
		}
	};
	componentDidMount(){
		new WOW.WOW().init();	
	}
	render(){
		return(
			<Fragment>
				<Header />
				<div className="page-content bg-white">
					<PageTitle motherMenu="Careers" activeMenu="Careers" />
					
					{/* Careers Section */}
					<section className="content-inner" style={{padding: '80px 0'}}>
						<div className="container">
							<div className="section-head text-center mb-5">
								<h2 className="title">Join Our Team</h2>
								<div className="dlab-separator bg-primary"></div>
								<p>Star Giga is always looking for talented individuals who share our passion for excellence in real estate development. Join us in building the future of community living in the UAE.</p>
							</div>
							
							<div className="row">
								<div className="col-lg-8 mx-auto">
									{/* <div className="career-box" style={{
										backgroundColor: '#f8f8f8',
										padding: '40px',
										borderRadius: '10px',
										marginBottom: '30px'
									}}>
										<h3 className="title mb-3">Why Work With Star Giga?</h3>
										<ul style={{listStyle: 'none', padding: 0}}>
											<li style={{padding: '10px 0', borderBottom: '1px solid #e0e0e0'}}>
												<i className="ti-check-box" style={{color: '#d4a574', marginRight: '10px'}}></i>
												Competitive salary packages and benefits
											</li>
											<li style={{padding: '10px 0', borderBottom: '1px solid #e0e0e0'}}>
												<i className="ti-check-box" style={{color: '#d4a574', marginRight: '10px'}}></i>
												Professional development opportunities
											</li>
											<li style={{padding: '10px 0', borderBottom: '1px solid #e0e0e0'}}>
												<i className="ti-check-box" style={{color: '#d4a574', marginRight: '10px'}}></i>
												Work on landmark projects in the UAE
											</li>
											<li style={{padding: '10px 0', borderBottom: '1px solid #e0e0e0'}}>
												<i className="ti-check-box" style={{color: '#d4a574', marginRight: '10px'}}></i>
												Collaborative and innovative work environment
											</li>
											<li style={{padding: '10px 0'}}>
												<i className="ti-check-box" style={{color: '#d4a574', marginRight: '10px'}}></i>
												Opportunities for career growth
											</li>
										</ul>
									</div> */}
									
									<form className="contact-box dzForm p-a30 border-1" onSubmit={this.handleFormSubmit}>
										<h3 className="title-box">Apply to Work With Us</h3>
										<div className="dzFormMsg m-b20">
											{this.state.formFeedback && (
												<div className="alert alert-success">{this.state.formFeedback}</div>
											)}
											{this.state.formError && (
												<div className="alert alert-danger">{this.state.formError}</div>
											)}
										</div>
										<p className="mb-4" style={{color: '#666', fontSize: '16px'}}>We look forward to hearing from you</p>
										<div className="row">
											<div className="col-lg-6 col-md-6">
												<div className="form-group">
													<div className="input-group">
														<input name="firstName" type="text" required="" className="form-control" placeholder="First Name" />
													</div>
												</div>
											</div>
											<div className="col-lg-6 col-md-6">
												<div className="form-group">
													<div className="input-group">
														<input name="lastName" type="text" required="" className="form-control" placeholder="Last Name" />
													</div>
												</div>
											</div>
											<div className="col-lg-6 col-md-6">
												<div className="form-group">
													<div className="input-group">
														<input name="phone" type="text" required="" className="form-control" placeholder="Phone" />
													</div>
												</div>
											</div>
											<div className="col-lg-6 col-md-6">
												<div className="form-group">
													<div className="input-group"> 
														<input name="email" type="email" className="form-control" required="" placeholder="Your Email Id" />
													</div>
												</div>
											</div>
											<div className="col-lg-12 col-md-12">
												<div className="form-group">
													<div className="input-group">
														<textarea name="message" rows="4" className="form-control" required="" placeholder="Share your background and tell us why you'd be a great fit for our team"></textarea>
													</div>
												</div>
											</div>
											<div className="col-lg-12">
												<div className="form-group form-recaptcha">
													<div className="input-group">
														<div className="g-recaptcha" data-sitekey="6LefsVUUAAAAADBPsLZzsNnETChealv6PYGzv3ZN" data-callback="verifyRecaptchaCallback" data-expired-callback="expiredRecaptchaCallback"></div>
														<input className="form-control d-none" style={{display:"none"}} data-recaptcha="true" data-error="Please complete the Captcha" />
													</div>
												</div>
											</div>
											<div className="col-lg-12 col-md-12">
												<button name="submit" type="submit" value="Submit" className="btn btn-primary btn-lg" disabled={this.state.formSubmitting}>
													{this.state.formSubmitting ? 'Sending…' : 'Submit Application'}
												</button>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</section>
					{/* Careers Section End */}
				</div>
				<FooterPremium />
			</Fragment>
		)
	}
}

export default Careers;

